import { RootState } from '@src/store/store'
import { AppStateType } from '@src/store/ducks/app/reducer'

export const selectApp = (state: RootState): AppStateType => state.app

export const selectAppIsInitialized = (state: RootState): boolean => selectApp(state).isInitialized
export const selectAppIsOpenNav = (state: RootState): boolean => selectApp(state).isOpenNav
export const selectIsAuth = (state: RootState): boolean => selectApp(state).isAuth
